import { Component, Input, ViewEncapsulation, OnDestroy, inject, input } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { RequestService } from "../../../../../services/request/request";
import { ProgressService } from "../../../../../services/shared/progress";

@Component({
    selector: 'mi-send-dialog',
    imports: [],
    templateUrl: './send-dialog.html',
    styleUrl: './send-dialog.scss',
    encapsulation: ViewEncapsulation.None
})
export class SendDialogComponent implements OnDestroy {

    private translateService = inject(TranslateService);
    private router = inject(Router);
    private requestService = inject(RequestService);
    private progressService = inject(ProgressService);

    readonly unionReqiestId = input.required<number>();

    //#region _isSuccessSend
    public _isSuccessSend: boolean = false;
    get isSuccessSend(): boolean {
        return this._isSuccessSend;
    }
    @Input()
    set isSuccessSend(newValue: boolean) {
        if (newValue !== this._isSuccessSend) {
            this._isSuccessSend = newValue
        }
        this.updateByIsSuccessSend();

    }
    //#endregion

    subscription: Subscription = new Subscription()
    sendDialogText: any;
    sendDialogTextPath: string = 'send.error-dialog';



    initText() {
        if (this.isSuccessSend) {
            this.sendDialogTextPath = 'send.dialog';
        }
        this.subscription.add(this.translateService.stream(this.sendDialogTextPath).subscribe(translation => {
            this.sendDialogText = translation;
        }));
    }


    navigation() {
        this.requestService.clearRequestStore();
        this.progressService.resetTabs();
        this.router.navigate(['']);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    getDialogText() {
        let dialogtext = '';
        dialogtext = this.sendDialogText?.text;
        if (this.isSuccessSend) {
            dialogtext += ' ' + this.unionReqiestId();
        }
        return dialogtext;
    }

    getSrcImg() {
        const successPath = 'assets/images/components/app/attahments/send.svg';
        const errorPath = 'assets/images/shared/warning.svg';
        return this.isSuccessSend ? successPath : errorPath;
    }

    updateByIsSuccessSend() {
        this.initText();

    }
}